import { createFileRoute, Link } from '@tanstack/react-router';
import { Envelope } from '@phosphor-icons/react';
import { AuthHeading } from '../../../../../components/auth/auth-heading';
import { SocialAuthButtons } from '../../../../../components/auth/social-auth-buttons';
import { Icon } from '../../../../../components/Icon';
import { buttonClassName } from '../../../../../components/ui/button';
import { textLinkClass } from '../../../../../components/ui/text-link';

export const Route = createFileRoute('/subdomain/app/_auth/sign-in/')({
  component: SignInChooser,
});

function SignInChooser() {
  return (
    <>
      <AuthHeading title="Welcome back" subtitle="Sign in to see how your business is doing today." />

      <SocialAuthButtons callbackPath="/">
        <Link to="/subdomain/app/sign-in/email" className={buttonClassName({ variant: 'secondary', fullWidth: true })}>
          <Icon icon={Envelope} size="xl" />
          Sign in with email
        </Link>
      </SocialAuthButtons>

      <p className="text-center">
        <Link to="/subdomain/app/welcome" className={textLinkClass}>
          New here? Create an account
        </Link>
      </p>
    </>
  );
}
